var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#00318B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.8 265.374C462.74 254.444 468.04 241.104 468.04 224.954V104.884C457.658 112.697 445.013 116.913 432.02 116.894C412.38 116.894 394.95 107.464 383.99 92.884C373.04 107.464 355.6 116.894 335.96 116.894C322.44 116.894 309.97 112.424 299.94 104.894V224.954C299.94 241.114 305.24 254.454 313.18 265.374H454.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.23 260.974C332.65 296.954 384 308.994 384 308.994C384 308.994 435.35 296.954 457.77 260.974H310.23Z",
    fill: "#8DCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.66 172.204C396.98 173.624 405.38 182.374 414.22 192.354C415.61 193.924 405.48 204.984 407.31 204.944C412.06 204.824 426.58 187.684 426.65 211.594C426.7 227.534 396.65 239.104 396.65 239.104H414.12L414.77 254.064C414.77 254.064 419.74 240.724 422.36 237.494C430.46 227.524 442.54 207.424 456.95 210.394C471.36 213.364 443.29 196.474 443.29 196.474C443.29 196.474 438.09 181.284 426.66 179.504C416.6 177.934 412.37 176.994 400.02 172.204C398.34 171.554 396.14 169.884 396.66 172.204Z",
    fill: "#D87B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.69 198.684C360.76 197.694 364.15 186.054 368.38 173.404C369.05 171.414 383.69 174.674 382.73 173.104C380.26 169.044 358.15 165.024 378.83 153.024C392.62 145.024 417.65 165.294 417.65 165.294L408.93 150.154L421.57 142.124C421.57 142.124 407.52 144.474 403.43 143.814C390.75 141.774 367.3 141.334 362.68 127.364C358.06 113.394 357.43 146.154 357.43 146.154C357.43 146.154 346.87 158.234 351.03 169.034C354.69 178.534 355.99 182.674 358 195.764C358.29 197.554 357.94 200.294 359.69 198.684Z",
    fill: "#D87B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67 219.864C394.28 219.434 382.51 222.354 369.45 225.044C367.39 225.464 362.86 211.164 361.98 212.784C359.71 216.954 367.34 238.094 346.57 226.234C332.73 218.324 337.68 186.504 337.68 186.504L328.97 201.644L315.68 194.744C315.68 194.744 324.77 205.704 326.25 209.584C330.85 221.574 342.25 242.074 332.49 253.074C322.73 264.084 351.37 248.174 351.37 248.174C351.37 248.174 367.13 251.244 374.37 242.214C380.75 234.274 383.67 231.074 393.98 222.764C395.41 221.644 397.95 220.574 395.67 219.864Z",
    fill: "#D87B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.00585938H233.4L160 48.8941V-0.00585938H96V48.8941L22.6 -0.00585938H0V22.6941L46.1 53.3941H0V117.394H46.1L0 148.094V170.994H22.6L96 121.794V170.994H160V121.794L233.4 170.994H256.5V148.094L209.9 117.394H256.5V53.3941H209.9L256.5 22.6941V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 -0.00585938H112V69.3941H0V101.394H112V170.994H144V101.394H256.5V69.3941H144V-0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170.994V159.694L62.5 117.394H85.1L7.3 170.994H0ZM7.3 0.0942383L85.1 53.2942H62.5L0 11.0942V0.0942383H7.3ZM256.5 0.0942383V11.0942L193.5 53.3942H170.9L248.7 0.0942383H256.5ZM248.7 170.994L170.9 117.394H193.5L256.5 159.694V170.994H248.7Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.66789ec13b7b6dbfbe06c9623d5fc6d5.svg";
export { ForwardRef as ReactComponent };